import { Breadcrumb as ReactstrapBreadcrumb } from 'reactstrap'
import styled from 'styled-components'

const Breadcrumb = styled(ReactstrapBreadcrumb)`
  display: inline-block;
`
export default Breadcrumb
